// First parser-blocking script of hub.html, placed right after the splash markup so the splash is already
// painted and bindable while the app chunks are still downloading.
const CONTAINER_ID = "boot-splash";

const LABELS = {
  en: { loading: "Loading application", starting: "Starting" },
  fr: { loading: "Chargement de l'application", starting: "Démarrage" }
};

function readBundleManifest() {
  const meta = document.querySelector('meta[name="boot-bundles"]');
  if (!meta) return [];

  return (meta.getAttribute("content") || "")
    .split(";")
    .filter(Boolean)
    .map(entry => {
      const [url, size] = entry.split(",");
      return [url, parseInt(size, 10) || 0];
    });
}

function readSplash() {
  return {
    label: document.getElementById(`${CONTAINER_ID}-label`),
    fill: document.getElementById(`${CONTAINER_ID}-fill`)
  };
}

function trackBundleProgress(bundles, onProgress) {
  const remaining = new Map(bundles);
  const totalBytes = bundles.reduce((sum, [, size]) => sum + size, 0);
  let loadedBytes = 0;

  const consume = entries => {
    let changed = false;

    for (const entry of entries) {
      for (const [url, size] of remaining) {
        // Resource timing reports absolute URLs while the manifest holds build-time paths.
        if (entry.name.endsWith(url)) {
          remaining.delete(url);
          loadedBytes += size;
          changed = true;
        }
      }
    }

    if (changed) onProgress(totalBytes ? loadedBytes / totalBytes : 0);
  };

  const observer = new PerformanceObserver(list => {
    consume(list.getEntries());
    if (!remaining.size) observer.disconnect();
  });

  observer.observe({ type: "resource", buffered: true });
}

(function bootSplash() {
  const labels = LABELS[(navigator.language || "en").slice(0, 2)] || LABELS.en;
  const bundles = readBundleManifest().filter(([, size]) => size > 0);
  const { label, fill } = readSplash();

  if (!label || !fill) return;

  label.textContent = `${labels.loading}…`;

  if (!bundles.length || typeof PerformanceObserver === "undefined") return;

  trackBundleProgress(bundles, ratio => {
    const percent = Math.min(100, Math.round(ratio * 100));
    fill.style.width = `${percent}%`;
    label.textContent = percent < 100 ? `${labels.loading}… ${percent}%` : `${labels.starting}…`;
  });
})();
